import toast from "react-hot-toast";
import { getAge } from "../utils/date";
import { useDispatch } from "react-redux";
import { GenerateEmail, FilterEmailContent } from "../redux/v2/patient-invite/actions";
import useEmail from "./useEmail";

const usePrompt = (props) => {
    const dispatch = useDispatch();
    const { arrangeEmailContent } = useEmail();

    const arrangePromptValues = (prompt, properties) => {
        const stringifyArray = (arr) => {
            const equiVal = {
                "SU": "SUNDAY",
                "MO": "MONDAY",
                "TU": "TUESDAY",
                "WE": "WEDNESDAY",
                "TH": "THURSDAY",
                "FR": "FRIDAY",
                "SA": "SATURDAY",
            }
            let str = "";
            arr.forEach((item, i) => {
                str += ` - ${equiVal[item?.label] || item?.label}${i == arr.length - 1 ? "" : "\n"}`;
            });
            return str;
        }


        let processed = prompt;
        properties?.forEach((prop) => {
            processed = processed?.replace(`{{${prop?.key}}}`, Array.isArray(prop?.value) ? stringifyArray(prop?.value) : prop?.value);
        });

        return processed;
    }

    const arrangeEmailPrompt = (patient, prompt) => {
        const sp = patient?.sp;

        let processed = prompt;
        processed = processed.replace("{{patientName}}", patient?.first_name + " " + patient?.last_name);
        processed = processed.replace("{{patientAge}}", getAge(patient?.dob));
        processed = processed.replace("{{patientGoals}}", `\n - ${patient?.goal_2}\n - ${patient?.goal_3} \n`);
        processed = processed.replace("{{subjectiveSummary}}", `\n - ${patient?.subjective_summary || "none"} \n`);
        processed = processed.replace("{{objectiveSummary}}", `\n - ${patient?.objective_summary || "none"} \n`);
        processed = processed.replace("{{assessmentSummary}}", `\n - ${patient?.assessment_summary || "none"} \n`);
        processed = processed.replace("{{planSummary}}", `\n - ${patient?.plan_summary || "none"} \n`);

        processed = processed.replace("{{programName1}}", `${sp[0]?.title?.toUpperCase()}${sp[0]?.level ? (" - " + sp[0]?.level) : ""}\n`);
        processed = processed.replace("{{programName2}}", `${sp[1]?.title?.toUpperCase()}${sp[1]?.level ? (" - " + sp[1]?.level) : ""}\n`);
        processed = processed.replace("{{programName3}}", `${sp[2]?.title?.toUpperCase()}${sp[2]?.level ? (" - " + sp[2]?.level) : ""}\n`);

        processed = processed.replace("{{program1Description}}", `${sp[0]?.level == null ? sp[0]?.info : sp[0]?.[sp[0]?.level?.toLowerCase()]}`);
        processed = processed.replace("{{program2Description}}", `${sp[1]?.level == null ? sp[1]?.info : sp[1]?.[sp[1]?.level?.toLowerCase()]}`);
        processed = processed.replace("{{program3Description}}", `${sp[2]?.level == null ? sp[2]?.info : sp[2]?.[sp[2]?.level?.toLowerCase()]}`);

        return processed;
    }

    const arrangeEmailFilterPrompt = async (pPrompt, email) => {
        const arrangedEmail = await arrangeEmailContent(JSON.parse(email?.email_content));

        let processed = pPrompt;
        processed = processed.replace("{{emailContent}}", `"""\n${arrangedEmail}\n"""`);

        return processed;
    }

    const arrangeFilteredEmailPrompt = (arrangedEmailContent, prompt) => {
        let processed = prompt;
        processed = processed.replace("{{emailContent}}", `"""\n${arrangedEmailContent}\n"""`);

        return processed;
    }

    const handleGenerateEmail = async (patient, pPrompt, toastID) => {
        const processedPrompt = arrangeEmailPrompt(patient, pPrompt);
        const res = await dispatch(GenerateEmail(processedPrompt, patient?.id));
        if (res.success) {
            toast.success('Email generated!', {
                id: toastID,
            });
        } else {
            toast.error('Failed to generate email!', {
                id: toastID,
            });
        }
    }

    const handleFilterEmail = async (patient, pPrompt, email, toastID) => {

        const processedPrompt = await arrangeEmailFilterPrompt(pPrompt, email);

        const res = await dispatch(FilterEmailContent(processedPrompt, patient?.id, email));

        if (res.success) {
            toast.success('Email generated!', {
                id: toastID,
            });
        } else {
            toast.error('Failed to generate email!', {
                id: toastID,
            });
        }
    }

    const arrangeOnboardingResults = (results) => {
        let text = "", arranged = [], week = null, days = [];
        for (let x = 0; x < results.length; x++) {
            text = "";
            week = null;
            days = [];

            if (x == 0) {
                for (let y = 0; y < results[x].length; y++) {
                    week = results[x][y]
                    text += `- Week ${week?.weekNo}: ${week?.min} min/week \n`;
                }
                arranged.push({
                    key: "step1Result",
                    value: text
                });
            } else if (x == 1) {
                for (let y = 0; y < results[x].length; y++) {
                    week = results[x][y]
                    text += `- Week ${week?.weekNo}\n`;
                    days = week?.days
                    for (let z = 0; z < days.length; z++) {
                        text += `    - Day ${days[z]?.day}: ${days[z]?.min} min \n`;
                    }
                }
                arranged.push({
                    key: "step2Result",
                    value: text
                });
            }

        }

        return arranged;
    }


    return {
        arrangeEmailPrompt,
        arrangeEmailFilterPrompt,
        arrangeFilteredEmailPrompt,
        handleGenerateEmail,
        handleFilterEmail,
        arrangePromptValues,
        arrangeOnboardingResults,
    };
};

export default usePrompt;
